module.exports = __webpack_public_path__ + "img/Frame2.5cdccca2.png";